import { useState, useEffect } from "react";
import {
  Flex,
  Heading,
  Input,
  Button,
  Stack,
  Box,
  Image,
  Text,
  Code,
  FormControl,
  FormLabel,
} from "@chakra-ui/react";
import AuthService from "../../services/auth.service";
import { useHistory } from "react-router-dom";
import "./login.css";

const MfaSetup = () => {
  const history = useHistory();
  const [qrDataUrl, setQrDataUrl] = useState("");
  const [secret, setSecret] = useState("");
  const [setupToken, setSetupToken] = useState("");
  const [otp1, setOtp1] = useState("");
  const [otp2, setOtp2] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!AuthService.getMfaToken()) {
      history.push("/login");
      return;
    }
    AuthService.setupMfa().then(
      (data) => {
        setQrDataUrl(data.qrDataUrl);
        setSecret(data.secret);
        setSetupToken(data.setupToken);
      },
      () => {
        // mfaToken expired/invalid — back to login.
        history.push("/login");
      }
    );
  }, [history]);

  const handleSubmit = (event) => {
    event.preventDefault();
    setError("");
    setLoading(true);
    AuthService.verifyMfaSetup(setupToken, otp1, otp2).then(
      () => {
        history.push("/statistics");
      },
      (err) => {
        setLoading(false);
        setError(
          (err.response && err.response.data && err.response.data.message) ||
            "Verification failed. Please try again."
        );
      }
    );
  };

  return (
    <Flex
      flexDirection="column"
      width="100wh"
      height="100vh"
      backgroundColor="gray.200"
      justifyContent="center"
      alignItems="center"
    >
      <Stack
        flexDir="column"
        mb="2"
        justifyContent="center"
        alignItems="center"
        p={5}
        backgroundColor="white"
        boxShadow="md"
      >
        <Heading color="teal.400" size="md">
          Set up two-factor authentication
        </Heading>
        <Box minW={{ base: "90%", md: "468px" }}>
          <form onSubmit={handleSubmit}>
            <Stack spacing={4} p="1rem" backgroundColor="whiteAlpha.900">
              <Text fontSize="sm" textAlign="center">
                Scan this QR code with your authenticator app (Google
                Authenticator, Authy, ...).
              </Text>
              {qrDataUrl ? (
                <Flex justifyContent="center">
                  <Image src={qrDataUrl} alt="MFA QR code" boxSize="200px" />
                </Flex>
              ) : (
                <Text textAlign="center" fontSize="sm">
                  Loading…
                </Text>
              )}
              {secret ? (
                <Text fontSize="xs" textAlign="center">
                  Can't scan? Enter this key manually: <Code>{secret}</Code>
                </Text>
              ) : null}
              <Text fontSize="sm" textAlign="center">
                Then enter two consecutive codes from the app to confirm.
              </Text>
              <FormControl isRequired>
                <FormLabel fontSize="sm">First code</FormLabel>
                <Input
                  type="text"
                  inputMode="numeric"
                  maxLength={6}
                  placeholder="123456"
                  value={otp1}
                  onChange={(e) => setOtp1(e.currentTarget.value.trim())}
                />
              </FormControl>
              <FormControl isRequired>
                <FormLabel fontSize="sm">Next code (wait for it to refresh)</FormLabel>
                <Input
                  type="text"
                  inputMode="numeric"
                  maxLength={6}
                  placeholder="654321"
                  value={otp2}
                  onChange={(e) => setOtp2(e.currentTarget.value.trim())}
                />
              </FormControl>
              {error ? (
                <Text color="red.500" fontSize="sm" textAlign="center">
                  {error}
                </Text>
              ) : null}
              <Button
                borderRadius={0}
                type="submit"
                variant="solid"
                colorScheme="teal"
                width="full"
                isLoading={loading}
                isDisabled={!setupToken}
              >
                Enable MFA
              </Button>
            </Stack>
          </form>
        </Box>
      </Stack>
    </Flex>
  );
};

export default MfaSetup;
